import React from "react";
import { Helmet } from "react-helmet";

function SeoHead() {
  return (
    <Helmet>
      <html lang="es" />
      <title>PREL Merch | Puerto Rico Esports League</title>
      <meta
        name="description"
        content="Explora los primeros productos oficiales de merchandise de Puerto Rico Esports League."
      />
      <meta name="robots" content="noindex,nofollow" />
      <link rel="canonical" href="https://www.puertoricoesportleague.com/merch" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="PREL Merch" />
      <meta
        property="og:description"
        content="Primeros productos oficiales de merchandise de Puerto Rico Esports League."
      />
      <meta property="og:url" content="https://www.puertoricoesportleague.com/merch" />
      <meta property="og:image" content="/logo.png" />
    </Helmet>
  );
}

function ProductCard({ category, title, description, price, image }) {
  return (
    <article className="bg-[#111111] border border-[#242424] rounded-2xl overflow-hidden">
      <div className="aspect-square bg-[#161616] border-b border-[#242424] p-3 sm:p-5 flex items-center justify-center">
        <img
          src={image}
          alt={title}
          className="w-full h-full rounded-xl object-contain bg-[#111111] p-3 sm:p-5"
        />
      </div>
      <div className="p-5 sm:p-6">
        <div className="text-[#00f0ff] text-xs uppercase tracking-[0.16em] font-bold mb-3">{category}</div>
        <h2 className="text-2xl font-bold mb-2">{title}</h2>
        <p className="text-gray-300 leading-7 mb-5">{description}</p>
        <div className="flex items-center justify-between gap-3 flex-wrap mb-5">
          <div className="text-2xl font-extrabold">${price}</div>
          <div className="text-sm text-gray-400">Disponible próximamente</div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <button className="w-full sm:w-auto px-5 py-3 rounded-xl bg-[#00f0ff] text-black font-bold">
            Comprar próximamente
          </button>
          <button className="w-full sm:w-auto px-5 py-3 rounded-xl border border-[#2b2b2b] text-white font-semibold bg-transparent">
            Solicitar información
          </button>
        </div>
      </div>
    </article>
  );
}

export default function ShopPreviewPage() {
  return (
    <>
      <SeoHead />
      <div className="min-h-screen bg-black text-white font-sans">
        <main className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
          <section className="mb-8 sm:mb-10">
            <p className="text-[#00f0ff] uppercase tracking-[0.18em] text-xs font-bold mb-3">
              Puerto Rico Esports League
            </p>
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">PREL Merch</h1>
            <p className="text-gray-300 text-base sm:text-lg leading-8 max-w-3xl">
              Explora los primeros productos oficiales de Puerto Rico Esports League.
              Esta selección inicial de merch está pensada para comunidad, talento, staff y seguidores de PREL,
              con una línea visual alineada a la marca y preparada para futura integración de checkout.
            </p>
          </section>

          <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ProductCard
              category="Apparel"
              title="Official PREL Jersey"
              description="Jersey oficial de Puerto Rico Esports League diseñado para fans, talento, staff, hosts y comunidad. Una pieza pensada para representar la identidad competitiva y visual de PREL."
              price="35.00"
              image="/prel-jersey.JPG"
            />
            <ProductCard
              category="Accessories"
              title="PREL Mousepad"
              description="Mousepad oficial de PREL pensado para setups de gaming, streaming spaces, activaciones y uso diario. Un producto funcional y accesible para comenzar la línea de merchandise."
              price="10.00"
              image="/prel-mousepad.jpeg"
            />
          </section>

        </main>
      </div>
    </>
  );
}
